// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared hover tip — matches AdminDashboard .ops-bar-tip look. */

.app-tip {
  position: relative;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  max-width: 100%;
}

.app-tip--block {
  display: block;
}

.app-tip--stretch {
  display: flex;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 100%;
}

.app-tip--stretch > * {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
}

.app-tip__bubble {
  position: fixed;
  z-index: 1080;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  max-width: min(260px, calc(100vw - 16px));
  padding: 7px 9px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.97);
  border: 1px solid rgba(143, 155, 175, 0.22);
  box-shadow: 0 8px 18px rgba(52, 62, 94, 0.12);
  pointer-events: none;
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1.35;
  color: #5e6475;
  white-space: nowrap;
}

.app-tip__bubble--wrap {
  white-space: normal;
}

.app-tip__bubble--plain {
  max-width: min(280px, calc(100vw - 16px));
  padding: 9px 11px;
  gap: 0;
  font-weight: 500;
  line-height: 1.45;
  color: #5e6475;
}

.app-tip__bubble--plain .app-tip__bubble-text {
  color: #5e6475;
  font-weight: 500;
}

.app-tip__bubble-text {
  color: #1f2430;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/components/AppTooltip.css"],"names":[],"mappings":"AAAA,iEAAiE;;AAEjE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,6CAA6C;EAC7C,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,MAAM;EACN,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Shared hover tip — matches AdminDashboard .ops-bar-tip look. */\n\n.app-tip {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n  max-width: 100%;\n}\n\n.app-tip--block {\n  display: block;\n}\n\n.app-tip--stretch {\n  display: flex;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  height: 100%;\n}\n\n.app-tip--stretch > * {\n  flex: 1 1 auto;\n  min-width: 0;\n  width: 100%;\n}\n\n.app-tip__bubble {\n  position: fixed;\n  z-index: 1080;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  max-width: min(260px, calc(100vw - 16px));\n  padding: 7px 9px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.97);\n  border: 1px solid rgba(143, 155, 175, 0.22);\n  box-shadow: 0 8px 18px rgba(52, 62, 94, 0.12);\n  pointer-events: none;\n  font-size: 0.72rem;\n  font-weight: 600;\n  line-height: 1.35;\n  color: #5e6475;\n  white-space: nowrap;\n}\n\n.app-tip__bubble--wrap {\n  white-space: normal;\n}\n\n.app-tip__bubble--plain {\n  max-width: min(280px, calc(100vw - 16px));\n  padding: 9px 11px;\n  gap: 0;\n  font-weight: 500;\n  line-height: 1.45;\n  color: #5e6475;\n}\n\n.app-tip__bubble--plain .app-tip__bubble-text {\n  color: #5e6475;\n  font-weight: 500;\n}\n\n.app-tip__bubble-text {\n  color: #1f2430;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
